export default {
  data() {
    return {
      place: null,
    }
  },
  methods: {
    $setAddress(place){
      if (!place) {
        return false;
      }

      this.form.address = place.name;
      this.form.postcode = place.postal_code;
      this.form.zip = place.postal_code;
      this.form.city = place.locality;
      this.form.latitude = place.latitude;
      this.form.longitude = place.longitude;
      this.form.state = place.administrative_area_level_2;
    }
  }
};
